import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import { ALL_ITEM_PREMIUM_PAPER_BAGS } from "./itemJson";
import ItemList from "../../itemListContainer/itemList";

function JewelryPouchPage(props) {
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    const jewelsParam = props.match.params.jewels;
    const filtered = ALL_ITEM_PREMIUM_PAPER_BAGS[0].itemList.filter(item => item.itemSelected === jewelsParam);
    setSelectedItem(filtered)
  }, [props.match.params.jewels]); 


  return (
    <>
      <Helmet>
        <title>Wholesale Custom Packaging Branded Paper Bags | Lussopack</title>
        <meta name="description" content="Our premium paper bags are designed to boost your brand. With custom designs, logos, and various sizes for wholesale. Fast delivery from Thailand." />
        <meta name="keywords" content="packaging paper bags" />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href="https://lussopack.com/packaging/premium-paper-bags/" />  
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Premium Paper Bags"}
      />        
      <ItemList 
        selectedItem={selectedItem}
      />
    </>
  );
}

export default JewelryPouchPage;
